import type { IconSvgObject } from './types';

const LocationRemove01Icon: IconSvgObject = [
  ["path", { d: "M13.6177 21.367C13.1841 21.773 12.6044 22 12.0011 22C11.3978 22 10.8182 21.773 10.3845 21.367C6.41302 17.626 1.09076 13.4469 3.68627 7.37966C5.08963 4.09916 8.45834 2 12.0011 2C15.5439 2 18.9126 4.09916 20.316 7.37966C22.9082 13.4393 17.599 17.6389 13.6177 21.367Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15.5 11H8.5", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }]
];

export default LocationRemove01Icon;
